import { render } from "./Apps.vue?vue&type=template&id=82e5ca26&ts=true"
import script from "./Apps.vue?vue&type=script&lang=ts"
export * from "./Apps.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__